<template>
<div class="skills">

    <div class="skills-title-box">
    Technical skills &amp; areas of experience:
    </div>

<div class="boxes">
    <div class="skills-box">

        <ul class="skills-list">
            <li>HTML5</li>
            <li>CSS3</li>
            <li>JavaScript</li>
            <li>&#x21B3; jQuery</li>
        <li>Git/Github</li>
        </ul>
    </div>

                    <div class="skills-box">
        <ul class="skills-list">
            <li>Vue.js</li>
            <li>&#x21B3; Vuex</li>
            <li>
              React.js
            </li>
            <li>Webpack</li>
         <li>Sass</li>
        <li>Flexbox</li>
        <li>CSS Grid</li>
        <li>HTML5 Canvas</li>
        </ul>
    </div>

        <div class="skills-box">

        <ul class="skills-list">
            <li>Node.js</li>
            <li>Express</li>
            <li>MongoDB</li>
            <li>NeDB</li>
        </ul>
    </div>


    <div class="skills-box">

        <ul class="skills-list">
            <li>REST/HTTP</li>
        <li>Headless CMS</li>
            <li>State management</li>
            <li>Responsive design</li>
            <li>Version control</li>
            <li>
              SEO
            </li>
        <li>JAM stack</li>
        <li>
          MEVN stack
        </li>

        </ul>
    </div>

    <div class="skills-box">

        <ul class="skills-list">
        <li>AWS</li>
            <li>Heroku</li>
            <li>Netlify</li>
        <li>Stripe</li>
        </ul>
    </div>


    </div>

</div>

</template>
<script>
export default {
name: 'Skills'
}
</script>
<style>

/* SKILLS */

.skills {
grid-area: skills;
display: grid;
grid-gap: 40px;
max-width: 950px;
margin: auto;
justify-content: flex-start;
align-content: center;
grid-template-areas: "skills-title boxes";
}

.skills-title-box {
grid-area: skills-title;
padding:10px;
font-size: 20px;
line-height: 28px;
letter-spacing: 0.02em;
color: #F08080;
margin-bottom: 4px;
width: 190px;
font-weight: 300;

}

.skills-title {
text-transform: uppercase;
font-size: 20px;
line-height: 28px;
color: #f0bfb3;
margin-bottom: 8px;
font-weight: 300;
}

.boxes {
grid-area: boxes;
display: grid;
grid-gap: 35px;
grid-template-rows: auto auto;
grid-template-columns: minmax(auto,215px) minmax(auto, 170px) minmax(auto,200px);

}

.skills-box {
padding: 10px;

}

.skills-list {
list-style-type: none;
margin: 0;
padding: 0;
border-left: 1px solid #f0bfb3;
padding-left: 10px;
}

.skills-list li {
display: block;
padding-left: 3px;
padding-bottom: 4px;
font-size: 18px;
letter-spacing: 0.01em;
line-height: 25px;
font-weight: 300;
color:#a4a4a4;
}

.skills-list li:last-child {
padding-bottom: 0;
margin-bottom: 0;
}


    @media screen and (max-width: 975px) {
        .skills {
            max-width: 700px;
            margin: auto;

        }

    }

@media screen and (max-width: 700px) {
    .skills {
    grid-area: skills;
    justify-content: center;
    display: grid;
    grid-gap: 20px;
    max-width: 500px;
        margin: auto;
    grid-template-areas: "skills-title"
    "boxes";
    }

    .boxes {
    grid-area: boxes;
    display: grid;
    grid-gap: 30px;
    grid-template-columns: auto auto auto;

    }

    .skills-title-box {
    display: grid;
    justify-content: center;
    margin: auto;
    text-align: center;
    width: 250px;
    }

}

@media screen and (max-width: 600px) {
    .skills {
        max-width: 400px;
        grid-gap: 20px;
        font-size: 18px;
    }

    .boxes {
        grid-template-columns: auto auto;
        grid-gap: 20px;


    }

    .skills-list li {
display: block;
padding-left: 3px;
padding-bottom: 4px;
font-size: 18px;
line-height: 22px;
font-weight: 300;
}

    }



@media screen and (max-width: 400px){

      .skills {
    max-width: 390px;
    grid-gap: 20px;
grid-template-areas: "skills-title"
    "boxes";
          padding-left: 30px;
          padding-right: 30px;
          margin: auto;
          justify-content: center;
}

.boxes {
grid-gap: 25px;
    justify-content: center;
grid-template-columns: auto auto;
    margin: auto;
    }


    .skills-box {
padding: 10px;
}

    .skills-title-box {
    justify-content: center;
padding: 10px;
font-size: 20px;
text-align: center;
line-height: 30px;
margin: auto;
    font-weight: 300;
    color:  #F08080;

}

    .skills-title {
text-transform: uppercase;
font-size: 16px;
line-height: 20px;
color: #f0bfb3;;
margin-bottom: 8px;
}

.skills-list {
margin: 0;
padding: 0;
border-left: 1px solid #f0bfb3;
padding-left: 8px;
}

.skills-list li {
display: block;
padding-left: 3px;
padding-bottom: 4px;
font-size: 16px;
line-height: 20px;
font-weight: 300;
}

}

</style>
